import { jsx as _jsx } from "react/jsx-runtime";
import { hydrate } from "./hydrate.js";
/**
 * renders the content on the client side (csr), which is provided by the "hydrate" function.
 */
export function MDXClient(props) {
    const { onError: ErrorComponent, ...rest } = props;
    const { content, error } = hydrate(rest);
    if (error && !ErrorComponent)
        throw error;
    if (error && ErrorComponent)
        return _jsx(ErrorComponent, { error: error });
    return content;
}
//# sourceMappingURL=MDXClient.js.map